import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import commonDefaultAPI from '../api';

const getSafetyChassis = async () => {
  try {
    const response = await commonDefaultAPI.get(`safetychassis`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSafetyChassis;
